{
    "LinkInput_Title": "Título",
    "LinkInput_URL": "URL",
    "LinkInput_Target": "Alvo",
    "LinkInput_NewTab": "Abrir em nova aba",
    "LinkInput_CurrentTab": "Abrir na aba atual",
    "NAME": "LinkInputLanguage"
}